<template>

  <div class="mm" :class="{ 'active' : ready }">

    <h1 class="landing-h mod-mm">We
      <div class="mm-flip">
        <span :class="{ 'flip-in' : state === 'video', 'flip-out' : state === 'web' }">make videos.</span>
        <span :class="{ 'flip-in' : state === 'web', 'flip-out' : state === 'video' }">build websites.</span>
      </div>
    </h1>

    <h1 class="landing-h mod-mm">Really good
      <div class="mm-flip second">
        <span :class="{ 'flip-in' : state === 'video', 'flip-out' : state === 'web' }">videos.</span>
        <span :class="{ 'flip-in' : state === 'web', 'flip-out' : state === 'video' }">websites.</span>
      </div>
    </h1>

    <div class="mm-cta">
      <a class="button mm-cta-video" href="#start">I have a video project</a>
      <a class="button mm-cta-web" href="https://web.squaredaisy.com#start">I have a web project</a>
    </div>

  </div>




</template>

<script type="text/babel">

  export default {

    data() {
      return {
        state: this.init,
        ready: false,
        interval: 0
      }
    },

    mounted() {
      let vm = this;
      window.addEventListener('load', () => {
        vm.ready = true;
        setTimeout(()=> { vm.change() }, 5000)
      });
      window.addEventListener('resize', vm.mobileState);
      vm.mobileState();
    },

    props: {
      init: { type: String, default: ''}
    },

    computed: {
      first: function(){
        let vm = this;
        if (vm.state === 'video') { return 'make videos' ; }
        else if (vm.state === 'web') { return 'build websites'; }
      },

      last: function(){
        let vm = this;
        if (vm.state === 'video') { return 'videos' ; }
        else if (vm.state === 'web') { return 'websites'; }
      },
    },

    methods: {
      change(){
        let vm = this;
        vm.changeState();
        vm.interval = setInterval(() => { vm.changeState() }, 7000)
      },

      changeState(){
        let vm = this;
        if (vm.state === 'video'){ vm.state = 'web'; }
        else if (vm.state === 'web'){ vm.state = 'video'; }
      },
      
      mobileState(){
        let vm = this;
        if (window.matchMedia("(max-width: 800px)").matches) {
          vm.state = "video";
          clearInterval(vm.interval);
        }
      }
    }
  }

</script>
